module.exports = __webpack_public_path__ + "static/img/tow.eae3557.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newNmg/tow.png
// module id = pCxh
// module chunks = 1